import clsx from "clsx";
import type { ChangeEvent } from "react";
import { Logo } from "../branding";
import { Divider } from "../divider";
import type { ChildrenProps } from "../types";

/** Props Interface */
interface AuthFormProps extends ChildrenProps {
	onSubmit: (e: ChangeEvent<HTMLFormElement>) => void;
	"data-cy"?: string;
}

export function AuthForm({ onSubmit, children, "data-cy": dataCy }: AuthFormProps) {
	/** Render */
	return (
		<form
			className={clsx(
				"grid grid-rows-3 max-h-[70%]",
				"w-[425px] max-w-[90vw]",
				"p-0 card dark:bg-primary-950",
			)}
			style={{
				gridTemplateRows: "auto 1fr auto",
			}}
			onSubmit={onSubmit}
			data-cy={dataCy}
		>
			{children}
		</form>
	);
}

AuthForm.Header = function ({ children }: Partial<ChildrenProps>) {
	return (
		<div className="flex flex-col">
			{children ? (
				<div className="px-8 py-4">{children}</div>
			) : (
				<div className="py-12 form-card-logo-container">
					<Logo height="36" />
				</div>
			)}
			<Divider className="form-card-divider" />
		</div>
	);
};

AuthForm.Body = function ({ children }: ChildrenProps) {
	return <div className="grow-0 gap-6 p-8 min-h-0 overflow-y-auto v-stack">{children}</div>;
};

AuthForm.Footer = function ({ children }: ChildrenProps) {
	return (
		<div className="v-stack">
			<Divider className="form-card-divider" />
			<div className="gap-6 p-8 v-stack">{children}</div>
		</div>
	);
};

AuthForm.Row = function ({ children }: ChildrenProps) {
	return <div className="flex flex-row gap-6">{children}</div>;
};
